import * as React from 'react';

const SvgWalletMark = (props) => (
  <svg width={11} height={11} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m3.76 10.516.336-.432 1.128-2.352.096-.96h.336l.12.96 1.128 2.352.312.432 2.52-1.752-.312-.432-1.872-1.824-.888-.384.096-.336.936.216 2.592-.336.528-.168-1.008-3.024-.48.168-2.304 1.248-.648.72-.288-.24.48-.792.456-2.592V.484H3.952v.504l.48 2.592.48.792-.312.24-.648-.72-2.28-1.248-.504-.168L.184 5.5l.504.168 2.592.336.96-.216.072.336-.864.384-1.896 1.824-.288.432 2.496 1.752Z"
      fill="#FF5E18"
    />
  </svg>
);

export default SvgWalletMark;
